//security types
export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_USERS = "GET_USERS";

export const CHECK_TOKEN = "CHECK_TOKEN"

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";

export const USER_POST_LIST_REQUEST = 'USER_POST_LIST_REQUEST'
export const USER_POST_LIST_SUCCESS = 'USER_POST_LIST_SUCCESS'
export const USER_POST_LIST_FAIL = 'USER_POST_LIST_FAIL'

export const POST_LIST_REQUEST = 'POST_LIST_REQUEST'
export const POST_LIST_SUCCESS = 'POST_LIST_SUCCESS'
export const POST_LIST_FAIL = 'POST_LIST_FAIL'

export const POST_DETAILS_REQUEST = 'POST_DETAILS_REQUEST'
export const POST_DETAILS_SUCCESS = 'POST_DETAILS_SUCCESS'
export const POST_DETAILS_FAIL = 'POST_DETAILS_FAIL'

export const CREATE_POST_REQUEST = 'CREATE_POST_REQUEST'
export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS'
export const CREATE_POST_FAIL = 'CREATE_POST_FAIL'
export const CREATE_POST_RESET = 'CREATE_POST_RESET'

export const UPDATE_POST_REQUEST = 'UPDATE_POST_REQUEST'
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS'
export const UPDATE_POST_FAIL = 'UPDATE_POST_FAIL'
export const UPDATE_POST_RESET = 'UPDATE_POST_RESET'

export const DELETE_POST_REQUEST = 'DELETE_POST_REQUEST'
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS'
export const DELETE_POST_FAIL = 'DELETE_POST_FAIL'
export const DELETE_POST_DONE = 'DELETE_POST_DONE'
export const DELETE_POST_RESET = 'DELETE_POST_RESET'

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'

export const USER_LOGOUT = 'USER_LOGOUT'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'

export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL'
export const CREATE_COMMENT_RESET = 'CREATE_COMMENT_RESET'

export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_FAIL = 'DELETE_COMMENT_FAIL'
export const DELETE_COMMENT_RESET = 'DELETE_COMMENT_RESET'

export const GET_ALL_COMMENT_REQUEST = 'GET_ALL_COMMENT_REQUEST'
export const GET_ALL_COMMENT_SUCCESS = 'GET_ALL_COMMENT_SUCCESS'
export const GET_ALL_COMMENT_FAIL = 'GET_ALL_COMMENT_FAIL'

export const LIKE_UNLIKE_REQUEST = 'LIKE_UNLIKE_REQUEST'
export const LIKE_UNLIKE_SUCCESS = 'LIKE_UNLIKE_SUCCESS'
export const LIKE_UNLIKE_FAIL = 'LIKE_UNLIKE_FAIL'

export const VOTE_POST_REQUEST = 'VOTE_POST_REQUEST'
export const VOTE_POST_SUCCESS = 'VOTE_POST_SUCCESS'
export const VOTE_POST_FAIL = 'VOTE_POST_FAIL'

export const CREATE_SUBRIBBIT_REQUEST = 'CREATE_SUBRIBBIT_REQUEST'
export const CREATE_SUBRIBBIT_SUCCESS = 'CREATE_SUBRIBBIT_SUCCESS'
export const CREATE_SUBRIBBIT_FAIL = 'CREATE_SUBRIBBIT_FAIL'
export const CREATE_SUBRIBBIT_RESET = 'CREATE_SUBRIBBIT_RESET'

export const SUBRIBBIT_LIST_REQUEST = 'SUBRIBBIT_LIST_REQUEST'
export const SUBRIBBIT_LIST_SUCCESS = 'SUBRIBBIT_LIST_SUCCESS'
export const SUBRIBBIT_LIST_FAIL = 'SUBRIBBIT_LIST_FAIL'

export const OWNED_AND_JOINED_SUBRIBBIT_LIST_REQUEST = 'OWNED_AND_JOINED_SUBRIBBIT_LIST_REQUEST'
export const OWNED_AND_JOINED_SUBRIBBIT_LIST_SUCCESS = 'OWNED_AND_JOINED_SUBRIBBIT_LIST_SUCCESS'
export const OWNED_AND_JOINED_SUBRIBBIT_LIST_FAIL = 'OWNED_AND_JOINED_SUBRIBBIT_LIST_FAIL'

export const SUBRIBBIT_DETAILS_REQUEST = 'SUBRIBBIT_DETAILS_REQUEST'
export const SUBRIBBIT_DETAILS_SUCCESS = 'SUBRIBBIT_DETAILS_SUCCESS'
export const SUBRIBBIT_DETAILS_FAIL = 'SUBRIBBIT_DETAILS_FAIL'

export const REQUEST_JOIN_SUBRIBBIT_REQUEST = 'REQUEST_JOIN_SUBRIBBIT_REQUEST'
export const REQUEST_JOIN_SUBRIBBIT_SUCCESS = 'REQUEST_JOIN_SUBRIBBIT_SUCCESS'
export const REQUEST_JOIN_SUBRIBBIT_FAIL = 'REQUEST_JOIN_SUBRIBBIT_FAIL'

export const GET_SUBRIBBIT_MEMBERS_REQUEST = 'GET_SUBRIBBIT_MEMBERS_REQUEST'
export const GET_SUBRIBBIT_MEMBERS_SUCCESS = 'GET_SUBRIBBIT_MEMBERS_SUCCESS'
export const GET_SUBRIBBIT_MEMBERS_FAIL = 'GET_SUBRIBBIT_MEMBERS_FAIL'

export const GET_SUBRIBBIT_MEMBERS_FOR_MEMBERS_REQUEST = 'GET_SUBRIBBIT_MEMBERS_FOR_MEMBERS_REQUEST'
export const GET_SUBRIBBIT_MEMBERS_FOR_MEMBERS_SUCCESS = 'GET_SUBRIBBIT_MEMBERS_FOR_MEMBERS_SUCCESS'
export const GET_SUBRIBBIT_MEMBERS_FOR_MEMBERS_FAIL = 'GET_SUBRIBBIT_MEMBERS_FOR_MEMBERS_FAIL'

export const UPDATE_SUBRIBBIT_MEMBER_REQUEST = 'UPDATE_SUBRIBBIT_MEMBER_REQUEST'
export const UPDATE_SUBRIBBIT_MEMBER_SUCCESS = 'UPDATE_SUBRIBBIT_MEMBER_SUCCESS'
export const UPDATE_SUBRIBBIT_MEMBER_FAIL = 'UPDATE_SUBRIBBIT_MEMBER_FAIL'
export const UPDATE_SUBRIBBIT_MEMBER_RESET = 'UPDATE_SUBRIBBIT_MEMBER_RESET'

export const UPDATE_SUBRIBBIT_REQUEST = 'UPDATE_SUBRIBBIT_REQUEST'
export const UPDATE_SUBRIBBIT_SUCCESS = 'UPDATE_SUBRIBBIT_SUCCESS'
export const UPDATE_SUBRIBBIT_FAIL = 'UPDATE_SUBRIBBIT_FAIL'
export const UPDATE_SUBRIBBIT_RESET = 'UPDATE_SUBRIBBIT_RESET'

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_FAIL = 'GET_NOTIFICATIONS_FAIL'

export const GET_TOP_SUBRIBBITS_REQUEST = 'GET_TOP_SUBRIBBITS_REQUEST'
export const GET_TOP_SUBRIBBITS_SUCCESS = 'GET_TOP_SUBRIBBITS_SUCCESS'
export const GET_TOP_SUBRIBBITS_FAIL = 'GET_TOP_SUBRIBBITS_FAIL'

export const UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_PROFILE_REQUEST'
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS'
export const UPDATE_USER_PROFILE_FAIL = 'UPDATE_USER_PROFILE_FAIL'
export const UPDATE_USER_PROFILE_RESET = 'UPDATE_USER_PROFILE_RESET'

export const SEND_RESET_PASSWORD_EMAIL_REQUEST = 'SEND_RESET_PASSWORD_EMAIL_REQUEST'
export const SEND_RESET_PASSWORD_EMAIL_SUCCESS = 'SEND_RESET_PASSWORD_EMAIL_SUCCESS'
export const SEND_RESET_PASSWORD_EMAIL_FAIL = 'SEND_RESET_PASSWORD_EMAIL_FAIL'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
